import React, { useState, useEffect, useCallback } from "react";
import classes from "./ClassRosterId.module.css";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";

import { getClassRosterIds } from "../../services/userServices";
import BackdropComponent from "../Spinner/Spinner";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import applicationUsageLog from "../../utils/applicationUsagesLog";

const ClassRosterId = (props) => {
  const [loading, setLoader] = useState(false);
  const [rosterIds, setRosterIds] = useState([]);
  const [selectedRosterId, setSelectedRosterId] = useState("");
  const [selectedOptions, setSelectedOptions] = useState("");
  const [classRosterRequired, setClassRosterRequired] = useState(false);

  const { t } = useTranslation(["header"]);

  useEffect(() => {
    let cancelled = false;

    const loadRosters = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        await rosterList();
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to load rosters:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    loadRosters();

    return () => {
      cancelled = true;
    };
  }, []);

  const rosterList = useCallback(async () => {
    let userDetails = await getClassRosterIds();
    setRosterIds(
      userDetails.data.data.map((item) => item.ClassRosterId.toString()),
    );
    setSelectedRosterId(userDetails.data.data[0].ClassRosterId.toString());
  }, []);

  const viewButton = (id) => {
    if (selectedOptions) {
      window.open(`/contact-roster/${selectedOptions}`, "_blank");
      applicationUsageLog(
        localStorage.getItem("User"),
        localStorage.getItem("EmailId"),
        "ASTT",
        "Contact Roster",
      );
    } else {
      setClassRosterRequired(true);
    }
  };

  const handleChange = (event, value) => {
    setClassRosterRequired(false);
    setSelectedOptions(value);
  };

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <Grid className={"overfolow-scroll background-grey"} container>
        <Grid item xs={12}>
          <h5>&nbsp;</h5>
        </Grid>

        <Grid className={classes.keyData} item xs={4}>
          <span className={classes.spanTag}>{t("classRosterId")}</span>
        </Grid>
        <Grid item xs={8}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={rosterIds}
            sx={{ width: 300 }}
            onChange={(event, value) => handleChange(event, value)}
            renderInput={(params) => (
              <TextField {...params} label={t("classRosterId")} />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <p className="redColor">
            {classRosterRequired && t("requiredField")}
          </p>
        </Grid>

        <Grid className={classes.valueData} item xs={12}>
          <div>
            <button
              className={classes.slectProjectButton}
              onClick={() => viewButton(selectedRosterId)}
            >
              {t("generateReport")}
            </button>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default ClassRosterId;
